import {
    Accordion,
    Carousel,
    ProductsCarousel,
    MenuItemsCarousel
} from "@peracto/peracto-blocks-tailwind";

import Container from './Container'

const blocks = {
    plugins: {
        content: [Carousel, Accordion, ProductsCarousel, MenuItemsCarousel],
        layout: [Container],
    },
};

export default blocks;
